// Open-Meteo API integration - free, no API key required
export interface WeatherData {
  temperature: number | null;
  humidity: number | null;
  windSpeed: number | null;
  rain: number | null;
  pressure: number | null;
  uvIndex: number | null;
  pm25: number | null;
  pollenGrass: number | null;
  pollenBirch: number | null;
  pollenOlive: number | null;
  pollenMugwort: number | null;
  pollenRagweed: number | null;
  pollenAlder: number | null;
}

export async function fetchWeatherData(lat: number, lon: number, date: string): Promise<WeatherData> {
  const result: WeatherData = {
    temperature: null, humidity: null, windSpeed: null, rain: null,
    pressure: null, uvIndex: null, pm25: null,
    pollenGrass: null, pollenBirch: null, pollenOlive: null,
    pollenMugwort: null, pollenRagweed: null, pollenAlder: null,
  };

  if (!lat || !lon || !Number.isFinite(lat) || !Number.isFinite(lon)) return result;

  try {
    // Fetch weather data
    const weatherUrl = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&daily=temperature_2m_max,temperature_2m_min,relative_humidity_2m_mean,wind_speed_10m_max,rain_sum,surface_pressure_mean,uv_index_max&timezone=Europe/Rome&start_date=${date}&end_date=${date}`;
    const weatherRes = await fetch(weatherUrl);
    if (weatherRes.ok) {
      const data = await weatherRes.json();
      if (data.daily) {
        const d = data.daily;
        result.temperature = d.temperature_2m_max?.[0] != null && d.temperature_2m_min?.[0] != null
          ? Math.round((d.temperature_2m_max[0] + d.temperature_2m_min[0]) / 2 * 10) / 10
          : null;
        result.humidity = d.relative_humidity_2m_mean?.[0] ?? null;
        result.windSpeed = d.wind_speed_10m_max?.[0] ?? null;
        result.rain = d.rain_sum?.[0] ?? null;
        result.pressure = d.surface_pressure_mean?.[0] ?? null;
        result.uvIndex = d.uv_index_max?.[0] ?? null;
      }
    }
  } catch (e) {
    console.warn('Weather fetch failed:', e);
  }

  try {
    // Fetch air quality + pollen
    const aqUrl = `https://air-quality-api.open-meteo.com/v1/air-quality?latitude=${lat}&longitude=${lon}&daily=pm2_5_max,grass_pollen_max,birch_pollen_max,olive_pollen_max,mugwort_pollen_max,ragweed_pollen_max,alder_pollen_max&timezone=Europe/Rome&start_date=${date}&end_date=${date}`;
    const aqRes = await fetch(aqUrl);
    if (aqRes.ok) {
      const data = await aqRes.json();
      if (data.daily) {
        const d = data.daily;
        result.pm25 = d.pm2_5_max?.[0] ?? null;
        result.pollenGrass = d.grass_pollen_max?.[0] ?? null;
        result.pollenBirch = d.birch_pollen_max?.[0] ?? null;
        result.pollenOlive = d.olive_pollen_max?.[0] ?? null;
        result.pollenMugwort = d.mugwort_pollen_max?.[0] ?? null;
        result.pollenRagweed = d.ragweed_pollen_max?.[0] ?? null;
        result.pollenAlder = d.alder_pollen_max?.[0] ?? null;
      }
    }
  } catch (e) {
    console.warn('Air quality fetch failed:', e);
  }

  return result;
}
